/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiMemberDtoExternalPaymentDto } from './WebApiMemberDtoExternalPaymentDto';
import {
    WebApiMemberDtoExternalPaymentDtoFromJSON,
    WebApiMemberDtoExternalPaymentDtoFromJSONTyped,
    WebApiMemberDtoExternalPaymentDtoToJSON,
} from './WebApiMemberDtoExternalPaymentDto';
import type { WebApiMemberDtoPaymentDto } from './WebApiMemberDtoPaymentDto';
import {
    WebApiMemberDtoPaymentDtoFromJSON,
    WebApiMemberDtoPaymentDtoFromJSONTyped,
    WebApiMemberDtoPaymentDtoToJSON,
} from './WebApiMemberDtoPaymentDto';

/**
 * 
 * @export
 * @interface WebApiMemberDtoGetPaymentDto
 */
export interface WebApiMemberDtoGetPaymentDto {
    /**
     * 
     * @type {Array<WebApiMemberDtoPaymentDto>}
     * @memberof WebApiMemberDtoGetPaymentDto
     */
    manualPayments?: Array<WebApiMemberDtoPaymentDto> | null;
    /**
     * 
     * @type {Array<WebApiMemberDtoExternalPaymentDto>}
     * @memberof WebApiMemberDtoGetPaymentDto
     */
    externalPayments?: Array<WebApiMemberDtoExternalPaymentDto> | null;
}

/**
 * Check if a given object implements the WebApiMemberDtoGetPaymentDto interface.
 */
export function instanceOfWebApiMemberDtoGetPaymentDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoGetPaymentDtoFromJSON(json: any): WebApiMemberDtoGetPaymentDto {
    return WebApiMemberDtoGetPaymentDtoFromJSONTyped(json, false);
}

export function WebApiMemberDtoGetPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoGetPaymentDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'manualPayments': !exists(json, 'manualPayments') ? undefined : (json['manualPayments'] === null ? null : (json['manualPayments'] as Array<any>).map(WebApiMemberDtoPaymentDtoFromJSON)),
        'externalPayments': !exists(json, 'externalPayments') ? undefined : (json['externalPayments'] === null ? null : (json['externalPayments'] as Array<any>).map(WebApiMemberDtoExternalPaymentDtoFromJSON)),
    };
}

export function WebApiMemberDtoGetPaymentDtoToJSON(value?: WebApiMemberDtoGetPaymentDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'manualPayments': value.manualPayments === undefined ? undefined : (value.manualPayments === null ? null : (value.manualPayments as Array<any>).map(WebApiMemberDtoPaymentDtoToJSON)),
        'externalPayments': value.externalPayments === undefined ? undefined : (value.externalPayments === null ? null : (value.externalPayments as Array<any>).map(WebApiMemberDtoExternalPaymentDtoToJSON)),
    };
}

